import renderEpisodeLength from '@helpers/renderEpisodeLength';
import useLocalStorage from '@hooks/useStorage';
import Episode from '@models/Episode';
import Link from 'next/link';
import React, { useEffect, useRef, useState } from 'react';
import H5AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { useDispatch } from 'react-redux';
import { updateListenHistory } from 'src/redux/action';
import API from '@services/index';

interface AudioPlayerProps {
  episode: Episode;
  preAndNext?: { pre:number, next:number, episodesLength: number };
  isLocked?: boolean;
  isDarkMode: boolean;
  isCanceled?: any;
  isChanged?: any;
  isPause?: any;
  goto?: any;
}

function EpisodePlayer(props: AudioPlayerProps) {
  const [playBackRate, setPlayBackRate] = useState(1);
  const [listenHistory, setListenHistory] = useLocalStorage(
    'listen_history',
    []
  );
  const audioPlayer = useRef<H5AudioPlayer>();
  const [isPlaying, setPlaying] = useState(false);
  const {
    episode,
    preAndNext,
    isLocked,
    isDarkMode,
    isCanceled,
    isChanged,
    isPause,
    goto,
  } = props;
  const dispatch = useDispatch();
  const audio = audioPlayer.current?.audio?.current;
  const [device, setDevice] = useState('mobile');
  const [playerRate, setPlayerRate] = useState('1.0');
  const [isShowRate, setShowRate] = useState(false);
  const [isShowPlayer, setShowPlayer] = useState(false);
  const rates = ['0.5', '0.8', '1.0', '1.2', '1.5', '2.0', '3.0'];

  useEffect(() => {
    // console.log(episode)
    if (!audio) return;
    audio.addEventListener('ended', () => {
      isDarkMode ? setPlaying(true): setPlaying(false);
      setPlayerRate('1.0');
    });
  }, [audio]);

  useEffect(() => {
    isDarkMode ? setPlaying(true): setPlaying(false);
    setPlayerRate('1.0');
    // audio?.pause();
  }, [episode.audio]);

  const handleRWD=() => {
    if (window.innerWidth > 768) {
      setDevice('pc');
      setShowPlayer(false);
    } else  {
      setDevice('mobile');
    }
  };

  useEffect(()=>{
    window.addEventListener('resize',handleRWD);
    handleRWD();
    return(()=>{
      window.removeEventListener('resize',handleRWD);
    });
  },[]);

  function changePlaybackRate() {
    if (!audio) return;
    switch (playBackRate) {
      case 1:
        audio.playbackRate = 1.25;
        setPlayBackRate(1.25);
        return;
      case 1.25:
        audio.playbackRate = 1.5;
        setPlayBackRate(1.5);
        return;
      case 1.5:
        audio.playbackRate = 1.75;
        setPlayBackRate(1.75);
        return;
      case 1.75:
        audio.playbackRate = 2;
        setPlayBackRate(2);
        return;
      case 2:
        audio.playbackRate = 0.5;
        setPlayBackRate(0.5);
        return;
      case 0.5:
        audio.playbackRate = 1;
        setPlayBackRate(1);
        return;
    }
  }

  async function updateLHtoAPI(e: Event) {
    const t = Math.round((e.target as HTMLAudioElement).currentTime);
    await API.updateListenHistory(episode.id, t * 1000,
      episode.audio_length_sec * 1000);
  }

  async function updateLH(e: Event) {
    const t = Math.round((e.target as HTMLAudioElement).currentTime);
    dispatch(updateListenHistory(episode.id, t, episode.audio_length_sec));
    setListenHistory([
      ...listenHistory.filter((c) => c.episodeId !== episode.id),
      {
        episodeId: episode.id,
        time: t,
        total: episode.audio_length_sec,
      },
    ]);

    // 當播放到 30 秒的倍數，或距離收聽完成只剩 5 秒時，回報收聽紀錄到 API
    if (t % 30 === 0 || episode.audio_length_sec - t < 5)
      await updateLHtoAPI(e);
  }

  function currentTimeFormat(all_sec) {
    let h = Math.floor(all_sec / 3600);
    let m = Math.floor(all_sec / 60);
    let s = Math.floor(all_sec % 60);
    if (h > 0) m %= 60;
    let hour = h > 0 ? h.toString() + ':' : '';
    let min = m > 9 ? m.toString() + ':' : '0' + m.toString() + ':';
    let sec = s > 9 ? s.toString() : '0' + s.toString();
    return hour + min + sec;
  }

  function openRate() {
    setShowRate(!isShowRate);
  }

  function setRate(rate) {
    if (!audio) return;
    setPlayerRate(rate);
    audio.playbackRate = rate;
    setShowRate(false);
  }


  return (
    <div>
      { isDarkMode?
        <div>
          <div className='player-float'>
            <div
              className={ isShowPlayer? 'player-vertical':'player-horizontal' }
              style={{ cursor: device=='mobile' && !isShowPlayer && 'pointer' }}
              onClick={() => {
                device == 'mobile' && !isShowPlayer
                  && setShowPlayer(!isShowPlayer);
              }}>
              <div style={{ display: isShowPlayer? 'flex':'none' }}>
                <img
                  style={{ height:'16px', width:'16px', cursor:'pointer' }}
                  onClick={() => {
                    setShowPlayer(!isShowPlayer);
                    setShowRate(false);
                  }}
                  src={'/icons/expanded.svg'}
                  alt=''
                />
                <p style={{ margin:'0 auto',color:'#B0B0B0',fontSize:'12px' }}>
                  {episode['name']}
                </p>
              </div>
              <div
                className='lession-img'
                style={{ display: isShowPlayer? '':'none' }}
              >
                <img
                  style={{ height: isShowRate? '210px':'240px'}}
                  src={episode.image}
                  alt=''
                />
              </div>
              { isShowRate &&
                <div
                  className='player-rate'
                  style={{ position:isShowPlayer? 'initial':'absolute' }}
                >
                  <p className='title'>變更播放速度</p>
                  <div className={'rate ' + (!isShowPlayer && 'player-mobile')}>
                    {
                      rates.map((rate) => (
                        <a
                          className={playerRate==rate? 'rate-active':''}
                          onClick={() => {
                            setRate(rate);
                          }}
                          key={rate}
                        >
                          <p>{rate}x</p>
                        </a>
                      ))
                    }
                  </div>
                </div>
              }
              { !isShowRate &&
                <div
                  style={{
                    display: isShowPlayer? 'flex':'none',
                    justifyContent:'space-between', flexDirection:'row',
                    alignItems:'center', marginBottom:'32px'
                  }}
                >
                  <div className='lesson-title'>
                    <img
                      style={{ margin:'auto 0', cursor:'pointer' }}
                      onClick={() => {
                        props.goto(episode);
                      }}
                      src={'/icons/share.svg'}
                      alt=''
                    />
                    <p className='play-title' style={{ fontSize:'18px' }}>
                      {episode.title}
                    </p>
                  </div>
                  <a
                    className='play-rate'
                    style={{ marginRight: '9px' }}
                    onClick={() => {
                      openRate();
                    }}
                  >
                    <p>{playerRate}x</p>
                  </a>
                </div>
              }
              <div className='player-info'>
                <p
                  style={{
                    color: '#CCCCCC',
                    display: isShowPlayer? 'none':'',
                    fontSize: '14px',
                    wordSpacing: 'nowrap'
                  }}
                >
                  {currentTimeFormat(audio?.currentTime)} / {renderEpisodeLength(episode)}
                </p>
                <H5AudioPlayer
                  className={isShowPlayer? '':'player-mobile'}
                  style={{ display: isShowPlayer&&'block' }}
                  onListen={updateLH}
                  ref={audioPlayer}
                  autoPlay={true}
                  preload='auto'
                  src={isLocked ? '' : episode.audio}
                  layout='horizontal'
                  customProgressBarSection={
                    [ RHAP_UI.PROGRESS_BAR ]
                  }
                />
                <div
                  style={{
                    display: isShowPlayer? 'flex':'none',
                    fontSize: '14px',
                    justifyContent:'space-between',
                    marginTop:'12px'
                  }}
                >
                  <p style={{ color: '#CCCCCC' }}>
                    {currentTimeFormat(audio?.currentTime)}
                  </p>
                  <p style={{ color: '#CCCCCC' }}>
                    {renderEpisodeLength(episode)}
                  </p>
                </div>
                <div
                  className='lesson-title'
                  style={{ display: isShowPlayer? 'none':'grid' }}
                >
                  <img
                    className={ isShowPlayer? '':'player-mobile' }
                    style={{ margin:'auto 0', cursor:'pointer' }}
                    onClick={() => {
                      props.goto(episode);
                    }}
                    src={'/icons/share.svg'}
                    alt=''
                  />
                  <p className='play-title'>{episode.title}</p>
                </div>
              </div>

              <div
                className='control-box'
                style={{
                  marginTop: isShowPlayer? '28px':'',
                  gap: device == 'mobile' && isShowPlayer
                  && '28px'
                }}
              >
                <a
                  className={isShowPlayer? '':'player-mobile'}
                  onClick={() => {
                    preAndNext.pre > -1 && isChanged('pre');
                  }}
                >
                  <img
                    src={`/icons/${preAndNext.pre < 0 ? 'pre_gray':'pre'}.svg`}
                    loading='lazy'
                    alt=''
                    className='icon-40'
                  />
                </a>
                <a
                  className={isShowPlayer? '':'player-mobile'}
                  onClick={() => {
                    if (!audio) return;
                    audio.currentTime = audio.currentTime - 15;
                  }}
                >
                  <img
                    src={'/icons/Rewind_white.svg'}
                    loading='lazy'
                    alt=''
                    className='icon-40'
                  />
                </a>
                <a
                  className='play-button-box w-inline-block'
                  onClick={(event) => {
                    event.stopPropagation();
                    if (isLocked) return;
                    if (!isPlaying) {
                      audio?.play();
                      props.isPause(false);
                    } else {
                      audio?.pause();
                      props.isPause(true);
                    }
                    setPlaying(!isPlaying);
                  }}
                >
                  <img
                    className='play-btn'
                    style={{
                      height:
                      device == 'mobile' && isShowPlayer
                      && '60px',
                      width:
                      device == 'mobile' && isShowPlayer
                      && '60px'
                    }}
                    src={
                      isLocked
                        ? '/icons/lock.svg'
                        : isPlaying
                          ? '/icons/pause_white.svg'
                          : '/icons/play_white.svg'
                    }
                    loading='lazy'
                    alt=''
                  />
                </a>
                <a
                  className={isShowPlayer? '':'player-mobile'}
                  onClick={() => {
                    if (!audio) return;
                    audio.currentTime = audio.currentTime + 25;
                  }}
                >
                  <img
                    src={'/icons/fast-Fwd_white.svg'}
                    loading='lazy'
                    alt=''
                    className='icon-40'
                  />
                </a>
                <a
                  className={ isShowPlayer? '':'player-mobile' }
                  onClick={() => {
                    preAndNext.next <= preAndNext.episodesLength
                      && isChanged('next');
                  }}
                >
                  <img
                    src={
                      `/icons/${preAndNext.next > preAndNext.episodesLength?
                        'next_gray':'next'}.svg`
                    }
                    loading='lazy'
                    alt=''
                    className='icon-40'
                  />
                </a>
                <a
                  className='play-rate player-mobile'
                  style={{
                    display: isShowPlayer? 'none':'',
                    marginRight: '9px',
                    marginLeft: '28px'
                  }}
                  onClick={() => {
                    openRate();
                  }}
                >
                  <p>{playerRate}x</p>
                </a>
                <a
                  style={{ display: isShowPlayer? 'none':'' }}
                  onClick={() => {
                    props.isCanceled(false);
                  }}
                >
                  <img
                    src={'/icons/close.svg'}
                    loading='lazy'
                    alt=''
                    className='icon-40'
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        :
        <div className='episode-player-component'>
          <div className='trial-player'>
            <div className='player-content'>
              <div className='episode-cover'>
                <Link href={`/episode/${episode.id}`}>
                  <img
                    style={{ cursor: 'pointer' }}
                    src={episode.image}
                    loading='lazy'
                    alt=''
                    className='episode-image'
                  />
                </Link>
              </div>
              <div className='episode-info'>
                <Link href={`/episode/${episode.id}`}>
                  <h1
                    style={{ cursor: 'pointer' }}
                    className='h4 black-text mb8'
                  >
                    {episode.title}
                  </h1>
                </Link>
                <p className='tag filled ml0'>
                時間 {renderEpisodeLength(episode)}
                </p>
                <div className='player-slider-wrap'>
                  <H5AudioPlayer
                    onListen={updateLH}
                    ref={audioPlayer}
                    autoPlay={false}
                    preload='auto'
                    src={isLocked ? '' : episode.audio}
                  />
                </div>
              </div>
            </div>
            <div className='player-control'>
              <a
                className='play-speed-box w-inline-block'
                onClick={changePlaybackRate}
              >
                <p className='paragraph-3'>{audio?.playbackRate}x</p>
              </a>
              <div className='player-control-box'>
                <a
                  className='icon-box-40 w-inline-block'
                  onClick={() => {
                    if (!audio) return;
                    audio.currentTime = audio.currentTime - 15;
                  }}
                >
                  <img
                    src={'/icons/Rewind.svg'}
                    loading='lazy'
                    alt=''
                    className='icon-40'
                  />
                </a>
                <a
                  className='play-button-box w-inline-block'
                  onClick={() => {
                    if (isLocked) return;
                    if (!isPlaying) {
                      audio?.play();
                    } else {
                      audio?.pause();
                    }
                    setPlaying(!isPlaying);
                  }}
                >
                  <img
                    className='play-icon'
                    src={
                      isLocked
                        ? '/icons/lock.svg'
                        : isPlaying
                          ? '/icons/pause.svg'
                          : '/icons/play.svg'
                    }
                    loading='lazy'
                    alt=''
                  />
                </a>
                <a
                  className='icon-box-40 w-inline-block'
                  onClick={() => {
                    if (!audio) return;
                    audio.currentTime = audio.currentTime + 25;
                  }}
                >
                  <img
                    src={'/icons/fast-Fwd.svg'}
                    loading='lazy'
                    alt=''
                    className='icon-40'
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default EpisodePlayer;